import { categoryListSchema } from '@/schemas/category'
import { API_ENDPOINT } from '../../utils/api-client/api-endpoint'
import { handleActionRequest } from '../../utils/handle-action-request'

export const getCategoriesAction = async () => {
  return handleActionRequest({
    endpoint: API_ENDPOINT.category.getCategories(),
    schema: categoryListSchema,
  })
}
